import React, { Component } from 'react';
import { CONFIG } from '../../../../config';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import __ from 'lodash';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import history from '../../../../history';
import LearningContentReq from '../../../../entity/LearningContentReq';
import FilterMateriPemb from '../../../../entity/FilterMateriPembelajaran';
// import FilterSoal from '../../../../entity/FilterSoal';

class TeksForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'materi',
            action: 'add',
            // status: 'start',
            open: true,
            isFetching: false,
            isLoading: false,
            alertShow: false,
            resMessage: '',
            filterSekolah: true,
            filterPrime: false,
            data: props.location.state,
            dataMateri: {},
            idMateri: null,
            materi: null,
            dataEdit: {},
            judulLearning: ''
        };
    }

    async componentDidMount() {
        console.clear();
        console.time('TeksForm time');
        console.info('props data not null', this.props.data !== null);
        console.info('props data', this.props.data !== undefined);

        const param = this.props.location.state;
        console.info('param', param);
        // this.setState({ isFetching: true });

        if(this.props.location.state.idProfil !== null) {
            this.getKontenMateri(param.idProfil);

            this.setState({
                action: 'edit',
                judulLearning: param.judul
            })
        }

        /*
        (function() {
            if( window.localStorage ) {
                if(!localStorage.getItem('firstReLoad')) {
                    localStorage['firstReLoad'] = true;
                    window.location.reload();
                }
                else {
                    localStorage.removeItem('firstReLoad');
                }
            }
        })();
        */
        this.callScript();
        console.timeEnd('TeksForm time');
    }

    callScript() {
        console.info('callScript');

        (function() {
            if( window.localStorage ) {
                if(!localStorage.getItem('firstReLoad')) {
                    localStorage['firstReLoad'] = true;
                    window.location.reload();
                }
                else {
                    localStorage.removeItem('firstReLoad');
                    window.tinyMCE.get();

                    (function () {
                        var script = document.createElement("script");
                        script.type = "text/javascript";
                        script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
                        var config = 'MathJax.Hub.Config({' +
                            'extensions: ["tex2jax.js"],' +
                            'jax: ["input/TeX","output/HTML-CSS"]' +
                            '});' +
                            'MathJax.Hub.Startup.onload();';

                        if (window.opera) {
                            script.innerHTML = config
                        }
                        else {
                            script.text = config
                        }

                        script.addEventListener('load', function() {
                            window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
                        })

                        document.getElementsByTagName("head")[0].appendChild(script);
                    })();
                }
            }
        })();

        /*
        (function() {
            const script = document.createElement("script");
            script.src = "tinymce/tinymce.min.js";
            script.async = true;
            document.head.appendChild(script);

            const script2 = document.createElement("script");
            script2.src = "./tinymceinit.js";
            document.head.appendChild(script2);
        })();
        */

        /*
        ReactDOM.render(
            // <textarea className="tinymce_textarea" id="isiMateri" value="" required></textarea>, document.getElementById('isiMateri')
            <h1>Hello, world!</h1>, document.getElementById('isiMateri')
        )
        */
    }

    handleEditorChange = (content) => {
        // console.info('cek ',content);
        this.setState({
            materi: content
        })
    }

    getKontenMateri = async(id) => {
        this.setState({
            isFetching: true
        });

        const result = await accountManagement.get(CONFIG.LEARNING_GET_TEKS_PROFIL + id)
        .catch(function(error) {
            console.error(error);
        });

        if (result) {
            window.tinyMCE.get('isiMateri').setContent(result.data.data.isiMateri === null ? "" : result.data.data.isiMateri);

            this.setState({
                idMateri: result.data.data.idMateriPelajaran,
                materi: result.data.data.isiMateri,
                data: {...this.state.data,
                    idProfil: result.data.data.idProfil,
                    idMapel: result.data.data.idMapel,
                    idBab: result.data.data.idBab,
                    idSubBab: result.data.data.idSubBab,
                    idTematik: result.data.data.idTema,
                    idSubTematik: result.data.data.idSubTema,
                    idPembTematik: result.data.data.idPembTema,
                    idMateriPelajaran: result.data.data.idMateriPelajaran,
                    isiMateri: result.data.data.isiMateri,
                }
            })

            if(result.data.data.isiMateri !== undefined && result.data.data.isiMateri !== null) {
                // window.tinyMCE.activeEditor.setContent(result.data.data.isiMateri);
                this.setState({
                    filterSekolah: true,
                    filterPrime: false,
                    isFetching: false
                })

                // window.tinyMCE.get('isiMateri').setContent(result.data.data.isiMateri);
                if(!__.isEmpty(this.state.materi)) {
                    console.info('SetContent =>', this.state.materi);
                    console.info(document.getElementsByTagName("head")[0]);
                    // window.tinyMCE.get('isiMateri');
                    console.info(window.tinyMCE);
                    console.info(window.tinyMCE.setup);
                    console.info(window.tinyMCE.get());
                    console.info(window.tinyMCE.get('isiMateri'));
                    console.info(document.getElementById('isiMateri'));
                    // console.info(window.tinyMCE.activeEditor.setContent === null);
                    // await window.tinymce.activeEditor.setContent(this.state.materi);
                    // window.tinymce.activeEditor.setContent('<p>Hello world!</p>');
                    // window.tinymce.activeEditor.setContent(this.state.materi);
                    // window.tinyMCE.get('isiMateri').setContent(this.state.data.isiMateri);
                    // await window.tinyMCE.get('isiMateri').setContent(this.state.materi === null ? '' : this.state.materi);
                    // window.tinyMCE.get('isiMateri').setContent(result.data.data.isiMateri);
                }
            }
            else {
                this.setState({
                    filterSekolah: false,
                    filterPrime: true,
                    isFetching: false
                })

                if(this.state.data.idSubBab !== null) {
                    this.getMapel(this.state.data.idKelas, this.state.data.idGuru);
                    this.getBab(this.state.data.idMapel);
                    this.getSubBab(this.state.data.idBab);
                }
                else {
                    this.getTematik(this.props.location.state.idKelas);
                    this.getSubTematik(this.state.data.idTematik);
                    this.getPembTematik(this.state.data.idSubTematik);
                }

                this.btnTampil();
            }

        }
    }

    handleInput = (evt) => {
        console.clear();
        const value = evt.target.value;

        this.setState({
            judulLearning: value
        });
    }

    /* Add */
    changeSumber = (e) => {
        console.clear();
        console.time('TeksForm changeSumber time');
        let value = e.target.value;
        console.info('changeSumber', value);
        /* let value;
        if(this.state.action === 'add') {
            value = e.target.value;
        }
        else {
            value = e;
        } */

        console.groupCollapsed('changeSumber');
        console.info('value', value);
        console.info('idKelas', this.state.data.idKelas);
        console.info('props data not null', this.props.data !== null);
        console.groupEnd();

        if(value === 'PRIME') {
            this.setState({
                filterPrime: true,
                filterSekolah: false
            })

            if(this.props.data !== null && this.props.data !== undefined) {
                /*
                this.getRencBelKelasParalel(this.props.data.idRencana);
                this.getKelasParalel(this.state.data.idKelas);
                */
                this.getMapel(this.state.data.idKelas, this.state.data.idGuru);
                this.getBab(this.state.data.idMapel);
                this.getSubBab(this.state.data.idBab);

                this.getTematik(this.state.data.idKelas);
            }
            else {
                this.getMapel(this.state.data.idKelas, this.state.data.idGuru);

                this.getTematik(this.state.data.idKelas);
            }
        }
        else {
            /*
            (function() {
                if( window.localStorage ) {
                    if(!localStorage.getItem('firstReLoad')) {
                        localStorage['firstReLoad'] = true;
                        window.location.reload();
                    }
                    else {
                        localStorage.removeItem('firstReLoad');
                    }
                }
            })();
            */
            this.callScript();

            this.setState({
                filterPrime: false,
                filterSekolah: true
            })
        }
        console.timeEnd('TeksForm changeSumber time');
    }

    getMapel = async(idKelas, idGuru) => {
        this.setState({
            isFetching: true,
            mapel: [],
            bab: [],
            subbab: []
        });

        const resMapel = await accountManagement.get(CONFIG.GURU_GET_MAPEL_BY_KELAS, {
            params: {idKelas: (idKelas === null ? 0 : idKelas), idGuru: idGuru}
        }).catch(function(error) {
            console.error('getMapel', error);
        })

        if(resMapel) {
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    mapel: resMapel.data.data,
                    data: {...this.state.data,
                        idKelas: idKelas
                    }
                })
            }
            else {
                this.setState({
                    resMessage: resMapel.data.errorSchema.errorMessage
                })
            }

            this.setState({
                isFetching: false
            });
        }
    }

    getBab = async(id) => {
        this.setState({
            isFetching: true,
            bab: [],
            subbab: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_BAB + id)
        .catch(function(error) {
            console.error('getBab', error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    bab: res.data.data,
                    data: {...this.state.data,
                        idMapel: id,
                        idTematik: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubBab = async(id) => {
        this.setState({
            isFetching: true,
            subbab:[]
        });

        // const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBBAB + id)
        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_LEARNING_GET_SUBBAB + this.state.type + '/' + id)
        .catch(function(error) {
            console.error('getSubBab', error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subbab: res.data.data,
                    data: {...this.state.data,
                        idBab: id,
                        idSubTematik: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    renderMapel() {
        let { mapel, data } = this.state;

        if(!__.isEmpty(mapel)) {
            return mapel.map((m, indexMapel) => {
                return (
                    <option key={indexMapel} value={m.idMataPelajaran} selected={parseInt(data.idMapel) === m.idMataPelajaran}>{m.namaMataPelajaran}</option>
                )
            })
        }
    }

    renderBab() {
        let { bab, data } = this.state;

        if(!__.isEmpty(bab)) {
            return bab.map((item, indexBab) => {
                return (
                    <option key={indexBab} value={item.idBab} selected={parseInt(data.idBab) === item.idBab}>{item.namaBab}</option>
                    // <option key={indexBab} value={item.idBab} selected={data.idBab === item.idBab}>{item.namaBab}</option>
                )
            })
        }
    }

    renderSubBab() {
        let { subbab, data } = this.state;

        if(!__.isEmpty(subbab)) {
            return subbab.map((item, indexSubBab) => {
                return (
                    <option key={indexSubBab} value={item.idSubBab} selected={parseInt(data.idSubBab) === item.idSubBab}>{item.namaSubBab}</option>
                )

                /*
                if(parseInt(data.idSubBab) === item.idSubBab) {
                    return ( <option value={item.idSubBab} selected>{item.namaSubBab}</option> )
                }
                else {
                    return ( <option value={item.idSubBab} >{item.namaSubBab}</option> )
                }
                */
            })
        }
    }

    getTematik = async(id) => {
        this.setState({
            isFetching: true,
            tematik: [],
            subTematik: [],
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: {idKelas: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error('getTematik', error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    tematik: res.data.data,
                    data: {...this.state.data,
                        idKelas: id
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubTematik = async(id) => {
        this.setState({
            isFetching: true,
            subTematik: [],
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBTEMA, {
            params: {idTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error('getSubTematik', error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subTematik: res.data.data,
                    data: {...this.state.data,
                        idTematik: id,
                        idMapel: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getPembTematik = async(id) => {
        this.setState({
            isFetching: true,
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_PEMBTEMA, {
            params: {idSubTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error('getPembTematik', error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    pembTematik: res.data.data,
                    data: {...this.state.data,
                        idSubTematik: id,
                        idBab: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    mapelOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('mapelOnChange', id);

        this.setState({
            subTematik: [],
            pembTematik: [],
            bab: [],
            subbab: []
        })

        if(id !== '') {
            this.getBab(id);
        }
    }

    babOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('babOnChange', id);

        this.setState({
            pembTematik: [],
            subbab: []
        })

        if(id !== '') {
            this.getSubBab(id);
        }
    }

    subBabOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('subBabOnChange', id);

        if(id !== '') {
            this.setState({
                data: {...this.state.data,
                    idSubBab: id,
                    idPembTematik: null
                }
            })
        }
    }

    temaOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('temaOnChange', id);

        this.setState({
            data: {...this.state.data,
                /* idProfil: result.data.data.idProfil,
                idMapel: result.data.data.idMapel,
                idBab: result.data.data.idBab,
                idSubBab: result.data.data.idSubBab,
                idTematik: result.data.data.idTema, */
                idSubTematik: null,
                idPembTematik: null,
                idMateriPelajaran: null,
                isiMateri: null,
            },
            subTematik: [],
            pembTematik: [],
            bab: [],
            subbab: []
        })

        if(id !== '') {
            this.getSubTematik(id);
        }
    }

    subTemaOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('subTemaOnChange', id);

        this.setState({
            pembTematik: [],
            subbab: []
        })

        if(id !== '') {
            this.getPembTematik(id);
        }
    }

    pembTemaOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('pembTemaOnChange', id);

        if(id !== '') {
            this.setState({
                data: {...this.state.data,
                    idSubBab: null,
                    idPembTematik: id
                }
            })
        }
    }

    btnTampil = async(e) => {
        console.time('TeksForm btnTampil time');

        this.setState({
            isFetching: true
        });
        let idSubBab = this.state.data.idSubBab;
        let idPembTematik = this.state.data.idPembTematik;

        console.groupCollapsed('Param btnTampil');
        console.info('idSubBab', (this.state.filterPrime && idSubBab !== null ? idSubBab : 0));
        console.info('idPembTematik', (this.state.filterPrime && idPembTematik !== null ? idPembTematik : 0));
        console.info('typeContent', this.state.type);
        console.info('kodeOwner', document.getElementById('sumber').value);

        // const result = await accountManagement.post(CONFIG.SOAL_FILTERSOAL, {...FilterSoal,
        const result = await accountManagement.post(CONFIG.LEARNING_GET_CONTENT_MATERI, {...FilterMateriPemb,
            idSekolah: this.state.data.idSekolah,
            idGuru: this.state.data.idGuru,
            idSubBab: (this.state.filterPrime && idSubBab !== null ? idSubBab : null),
            idPembTema: (this.state.filterPrime && idPembTematik !== null ? idPembTematik : null),
            typeContent: this.state.type,
            owner: document.getElementById('sumber').value
        }).catch(function(error) {
            console.error('btnTampil', error);
        });

        if (result) {
            console.info('Result Materi', result);
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    materi: result.data.data
                });
            }
            else {
                this.setState({
                    resMessage: result.data.errorSchema
                })
            }
        }

        this.setState({
            isFetching: false,
            open: false
        });
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);

        console.groupEnd();
        console.timeEnd('TeksForm btnTampil time');
    }

    renderMateri = () => {
        const { open, materi } = this.state;

        console.groupCollapsed('renderMateri');
        console.info('open', open);
        console.info('materi', materi);
        console.groupEnd();

        if(!open) {
            return (
                <Row style={{ marginTop: '10px' }}>
                    <Col style={{ marginBottom: '30px' }}>
                        <table className="table">
                            <tbody>
                                { materi.map((dataMateri, i) =>
                                    ( dataMateri.kodeOwner === 'PRIME' &&
                                        <tr key={dataMateri.idMateri}>
                                            <td>
                                                <div dangerouslySetInnerHTML={{__html: dataMateri.isiMateri}}></div>
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            )
        }
    }
    /* Add */

    handleBack = () => {
        this.setState({
            data: {...this.state.data,
                idProfil: null,
                idMapel: null,
                idBab: null,
                idSubBab: null,
                idTematik: null,
                idSubTematik: null,
                idPembTematik: null,
                idMateriPelajaran: null,
                isiMateri: null,
            }
        })
        history.push({
            pathname: '/learning_konten/MATERI/',
            state: this.state.data
        })
    }

    handleSubmit = async() => {
        console.clear();
        console.time('TeksForm handleSubmit time');
        var sumber = document.getElementById('sumber').value;
        // console.info('isi content', window.tinyMCE.get('isiMateri').getContent());
        if(this.state.judulLearning === '') {
            this.setState({
                alertShow: true,
                resMessage: 'Silahkan Input Judul Materi Learning... !!'
            })
            document.getElementById("judul").focus();
            return false;
        }
        console.groupCollapsed('CEK PARAMETER');
        console.info('data.idRencana', this.state.data.idRencana);
        console.info('data.idKelas', this.state.data.idKelas);
        console.info('data.idMapel', this.state.data.idMapel);
        console.info('data.isiMateri', document.getElementById('isiMateri'));
        // console.info('data.idMapel', window.tinyMCE.activeEditor.getContent());
        console.groupEnd();
        // return false;
        let value;

        if(sumber === 'PSEP') {
            value = window.tinyMCE.activeEditor.getContent();
            if (__.isEmpty(value)) {
                this.setState({
                    alertShow: true,
                    resMessage: 'Perhatian... Isi Materi Tidak Boleh Kosong...'
                })
                return false;
            }
        }
        else {
            value = null;
        }

        if (window.confirm('Konfirmasi Simpan ?')) {
            this.setState({
                isFetching: true
            });
            let { data, action } = this.state
            if(data.owner === 'PRIME') {
                action = 'add';
            }
            console.info(action);

            if(action === 'add') {
                const response = await accountManagement.post(CONFIG.LEARNING_POST_PEMB_LATIHAN, {...LearningContentReq,
                    idRencana: data.idRencana,
                    idKelas: data.idKelas,
                    idMapel: data.idMapel,
                    idBab: data.idBab,
                    idSubBab: data.idSubBab,
                    idPembTematik: data.idPembTematik,
                    idTematik: data.idTematik,
                    idSubTematik: data.idSubTematik,
                    idMateri: this.state.idMateri,
                    judul: this.state.judulLearning,
                    isiMateri: value,
                    owner: 'GURU',
                    tipeKontent: 'MATERI',
                    sumber : sumber
                }).catch(function(error) {
                    console.error(error);
                });

                if(response) {
                    if(response.data.code === '200') {
                        history.push({
                            pathname: '/learning_konten/MATERI/',
                            state: this.state.data
                        })
                    }
                    else {
                        this.setState({
                            alertShow: true,
                            resMessage: response.data.msg
                        })
                    }
                    this.setState({
                        isFetching: false
                    });
                }
            }
            else if(action === 'edit') {
                console.info('ISI', window.tinyMCE.activeEditor.getContent());
                const response = await accountManagement.post(CONFIG.LEARNING_POST_EDIT_PEMB_LATIHAN, {LearningContentReq,
                    idProfilePemLat: data.idProfil,
                    idMateri: this.state.idMateri,
                    judul: this.state.judulLearning,
                    isiMateri: value,
                    tipeKontent: 'MATERI'
                }).catch(function(error) {
                    console.error(error);
                });

                if(response) {
                    if(response.data.code === '200') {
                        history.push({
                            pathname: '/learning_konten/MATERI/',
                            state: this.state.data
                        })
                    }
                    else {
                        this.setState({
                            alertShow: true,
                            resMessage: response.data.msg
                        })
                    }
                    this.setState({
                        isFetching: false
                    });
                }
            }
        }

        console.timeEnd('TeksForm handleSubmit time');
    }

    render() {
        console.groupCollapsed('This Render TeksForm Cek State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        const { data } = this.state;

        return (
            <div className="container-fluid" style={{ marginTop: '20px', marginBottom:'50px' }}>
                <LoaderModal isFetching={this.state.isFetching} />
                <Row>
                    <Col>
                        <h3>Learning Teks: {this.state.action}</h3>
                    </Col>
                    <Col>
                        <Button variant="outline-danger pull-right" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.handleBack() }}>
                            Keluar <i className="fa fa-arrow-right"></i>
                        </Button>
                    </Col>
                </Row>

                {this.loadAlert()}
                <Row style={{ marginTop: '20px' }}>
                    <div className="form-group col-sm-2">Pilih Sumber Soal :</div>
                    <div className="form-group col-sm-2">
                        <select className="form-control" name="sumber" id="sumber" value={this.state.filterSekolah ? 'PSEP' : 'PRIME'} onChange={this.changeSumber} ref={this.sumber}>
                            <option value="PSEP">Sekolah</option>
                            <option value="PRIME">Eduprime</option>
                        </select>
                    </div>
                </Row>

                <Row style={{ marginTop: '10px' }}>
                    <div className="form-group col-sm-2">Judul Learning :</div>
                    <div className="form-group col-sm-10">
                        <input type="text" className="form-control" id="judul" onChange={this.handleInput} value={this.state.judulLearning} maxLength="100" placeholder="Input Judul Learning..." required/>
                    </div>
                </Row>


                { this.state.filterSekolah &&
                    <Row style={{ marginTop: '20px' }}>
                        <Col>
                            {/* <textarea className="tinymce_textarea" id="isiMateri" required><div dangerouslySetInnerHTML={{__html: this.state.dataMateri.isiMateri}}></div></textarea> */}
                            <textarea className="tinymce_textarea" id="isiMateri" required></textarea>
                        </Col>
                    </Row>
                }

                { this.state.filterPrime &&
                    <>
                        <Row>
                            <input type="hidden" id="upload" value="0"/>
                        </Row>

                        <Form.Group>
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <a className="nav-link active" data-toggle="tab" href="#one">Mata Pelajaran</a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#two">Tematik</a>
                                </li>
                            </ul>


                            <div className="tab-content" style={{ marginTop: '1em' }}>
                                <div className="tab-pane active" id="one">
                                    <Row >
                                        <Col>
                                            <Form.Group controlId="mapel">
                                                <select className="form-control" name="mapel" onChange={e => this.mapelOnChange(e)}>
                                                    <option value="">Pilih Mata Pelajaran...</option>
                                                    {this.renderMapel()}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="bab">
                                                <select className="form-control" name="bab" onChange={(e) => this.babOnChange(e)}>
                                                    <option value="">Pilih Bab...</option>
                                                    {this.renderBab()}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="subBab">
                                                <select className="form-control" name="subBab" onChange={(e) => this.subBabOnChange(e)}>
                                                    <option value="">Pilih Sub Bab...</option>
                                                    {this.renderSubBab()}
                                                </select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="tab-pane" id="two">
                                    <Row >
                                        <Col>
                                            <Form.Group controlId="tema">
                                                <select className="form-control" name="tema" value={data.idTematik} onChange={(e) => this.temaOnChange(e)}>
                                                    <option value="">Pilih Tematik...</option>
                                                    { this.state.tematik && this.state.tematik.map((data, i) =>
                                                        <option key={i} value={data.idTematik}>{data.namaTematik}</option>
                                                    )}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="subTema">
                                                <select className="form-control" name="subTema" value={data.idSubTematik} onChange={(e) => this.subTemaOnChange(e)}>
                                                    <option value="">Pilih Sub Tematik...</option>
                                                    { this.state.subTematik && this.state.subTematik.map((data, i) =>
                                                        <option key={i} value={data.idSubTematik}>{data.namaSubTematik}</option>
                                                    )}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="pembTema">
                                                <select className="form-control" name="pembTema" value={data.idPembTematik} onChange={(e) => this.pembTemaOnChange(e)}>
                                                    <option value="">Pilih Pembelajaran Tematik...</option>
                                                    { this.state.pembTematik && this.state.pembTematik.map((data, i) =>
                                                        <option key={i} value={data.idPembTematik}>{data.namaPembTematik}</option>
                                                    )}
                                                </select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Form.Group>

                        <div>
                            <Button variant="outline-dark btn-lg" onClick={() => {this.btnTampil()} }>
                                Tampilkan Materi
                            </Button>
                        </div>
                    </>
                }

                {this.renderMateri()}

                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        <Button type="submit" variant="outline-primary pull-right" onClick={() => this.handleSubmit()}>
                            Simpan <i className="fa fa-floppy-o"></i>
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }

    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    }
}

export default TeksForm;